/**
 * Cart Modal Quantity Fix
 *
 * Injects quantity +/- controls into the ajax cart modal items.
 * The original cartModalItemTemplate has renderProductQuantity commented out,
 * and this script patches that behavior without modifying app.js.
 */
(function () {
  'use strict';

  var CART_CONTAINER_ID = 'cart-container';
  var ITEM_SELECTOR = '.ajaxcart__product';
  var PRODUCT_LINE_SELECTOR = '.ajaxcart__product-line';
  var QTY_INJECTED_ATTR = 'data-qty-injected';

  function createQuantityHTML(key, quantity) {
    return (
      '<div class="quantity-select js-quantity-select" data-item-key="' + key + '">' +
        '<button type="button" class="quantity-select__button" data-increment="-1">' +
          '<span aria-hidden="true">-</span>' +
          '<span class="vh">Reduce quantity</span>' +
        '</button>' +
        '<input type="number" class="quantity-select__input" min="0" ' +
          'name="updates[]" value="' + quantity + '" ' +
          'data-key="' + key + '" />' +
        '<button type="button" class="quantity-select__button" data-increment="1">' +
          '<span aria-hidden="true">+</span>' +
          '<span class="vh">Increase quantity</span>' +
        '</button>' +
      '</div>'
    );
  }

  function getCartInstance() {
    // window.cartModal is set in app.js; its .cart property is the Cart singleton
    if (window.cartModal && window.cartModal.cart) {
      return window.cartModal.cart;
    }
    return null;
  }

  function initQuantityControls(container) {
    var items = container.querySelectorAll(ITEM_SELECTOR);

    items.forEach(function (itemEl) {
      if (itemEl.getAttribute(QTY_INJECTED_ATTR)) return;
      itemEl.setAttribute(QTY_INJECTED_ATTR, '1');

      var key = itemEl.getAttribute('data-key');
      if (!key) return;

      // Read current quantity from the price area or default to 1
      var priceEl = itemEl.querySelector('.ajaxcart__total-item-price');
      var existingInput = itemEl.querySelector('.quantity-select__input');
      if (existingInput) return; // already has controls

      // Try to figure out current quantity from cart state
      var quantity = 1;
      if (window.cartModal && window.cartModal._lastState) {
        var stateItems = window.cartModal._lastState.items || [];
        for (var i = 0; i < stateItems.length; i++) {
          if (stateItems[i].key === key) {
            quantity = stateItems[i].quantity;
            break;
          }
        }
      }

      var productLine = itemEl.querySelector(PRODUCT_LINE_SELECTOR);
      if (!productLine) return;

      // Insert quantity controls before the remove/price line
      var qtyWrapper = document.createElement('div');
      qtyWrapper.className = 'ajaxcart__quantity-wrap';
      qtyWrapper.innerHTML = createQuantityHTML(key, quantity);
      productLine.parentNode.insertBefore(qtyWrapper, productLine);

      // Wire up the +/- buttons
      var qtySelect = qtyWrapper.querySelector('.js-quantity-select');
      var input = qtySelect.querySelector('input');
      var buttons = qtySelect.querySelectorAll('button');

      function handleQuantityChange(newValue) {
        if (newValue < 0) newValue = 0;
        input.value = newValue;

        var cart = getCartInstance();
        if (!cart) return;

        if (newValue === 0) {
          itemEl.classList.add('is-removing');
          cart.removeItem(key).then(function () {
            if (itemEl.parentNode) {
              itemEl.parentNode.removeChild(itemEl);
            }
          });
        } else {
          itemEl.classList.add('is-updating');
          cart.updateItem(key, { quantity: newValue }).then(function () {
            itemEl.classList.remove('is-updating');
          });
        }
      }

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var increment = parseInt(btn.getAttribute('data-increment'), 10);
          var currentVal = parseInt(input.value, 10) || 0;
          handleQuantityChange(currentVal + increment);
        });
      });

      input.addEventListener('change', function () {
        handleQuantityChange(parseInt(input.value, 10) || 0);
      });
    });
  }

  // Observe #cart-container for content changes (the CartModal.buildCart rewrites innerHTML)
  function observeCartContainer() {
    var container = document.getElementById(CART_CONTAINER_ID);
    if (!container) return;

    // Also patch the cartModal to store state for quantity lookup
    if (window.cartModal && !window.cartModal._patchedState) {
      window.cartModal._patchedState = true;
      var origBuildCart = window.cartModal.buildCart;
      if (origBuildCart) {
        window.cartModal.buildCart = function (state) {
          window.cartModal._lastState = state;
          origBuildCart.call(window.cartModal, state);
          // After buildCart renders, inject our quantity controls
          setTimeout(function () {
            initQuantityControls(container);
          }, 0);
        };
      }
    }

    // Use MutationObserver as fallback for any other re-renders
    var observer = new MutationObserver(function () {
      initQuantityControls(container);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  // Wait for app.js to initialize (it uses defer)
  function init() {
    if (document.getElementById(CART_CONTAINER_ID) && window.cartModal) {
      observeCartContainer();
    } else {
      // Retry until cartModal is available
      var attempts = 0;
      var interval = setInterval(function () {
        attempts++;
        if (window.cartModal && document.getElementById(CART_CONTAINER_ID)) {
          clearInterval(interval);
          observeCartContainer();
        }
        if (attempts > 100) clearInterval(interval); // give up after ~10s
      }, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
